const meetingsToLinesResp = {
    error: null,
    overall: {
        value: 0.18216750652104677,
        significance: "negligible",
        explanation:
            "They are negligibly correlated, potentially meaning that how many hours you spent in meetings per day has no effect on how much you commit that day.",
        description:
            "For the entirety of time we have data on your meetings and commits, it seems that there is n negligible correlation between the time spent in meetings and chats and the amount of code produced.that the amount of time you spent in meetings does not correlate with the amount of lines of code committed.\n        \n        However, note that correlation does not necessarily mean causation, so it is advisable to keep an eye on this if you want to validate it. And in that case you could leave it as is, or increase meetings for a short period of time to see if it helps more or not!",
        error: null,
    },
    smaller_frame: {
        value: 0.5975953182306364,
        significance: "strong",
        explanation:
            "They are highly positively correlated, potentially meaning that days that you spend a high amount of time on meetings have a very high chance to be the days you commit many lines of code as well.",
        description:
            "For last 2 weeks, it seems that there is n strong positive correlation between the time spent in meetings and chats and the amount of code produced.that on days that you spend a high amount of time in meetings are also the days that the most lines of code are committed, and vice versa.\n        \n        However, note that correlation does not necessarily mean causation, so it is advisable to keep an eye on this if you want to validate it. And therefore it might be the case that the extended level of meetings helps produce more code (or you just commit it these days).",
        frame_name: "Last 2 weeks",
        error: null,
    },
    graph: {
        data: [
            {
                datetime: "2023-05-14T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2131067948,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-05-15T00:00:00.000",
                meetings: 3600.0,
                total: 659.0,
                correlation: 0.2149226792,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-05-16T00:00:00.000",
                meetings: 3600.0,
                total: 444.0,
                correlation: 0.2265367165,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-05-17T00:00:00.000",
                meetings: 7200.0,
                total: 95.0,
                correlation: 0.2120631279,
                trend_line: 49.0843795187,
            },
            {
                datetime: "2023-05-18T00:00:00.000",
                meetings: 3600.0,
                total: 178.0,
                correlation: 0.2155135947,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-05-19T00:00:00.000",
                meetings: 3600.0,
                total: 10.0,
                correlation: 0.209895299,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-05-20T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2240629145,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-05-21T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2368068703,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-05-22T00:00:00.000",
                meetings: 3600.0,
                total: 18.0,
                correlation: 0.2315745143,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-05-23T00:00:00.000",
                meetings: 3600.0,
                total: 84.0,
                correlation: 0.2309223964,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-05-24T00:00:00.000",
                meetings: 3600.0,
                total: 276.0,
                correlation: 0.2372490534,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-05-25T00:00:00.000",
                meetings: 3600.0,
                total: 56.0,
                correlation: 0.2347708647,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-05-26T00:00:00.000",
                meetings: 3600.0,
                total: 22.0,
                correlation: 0.2302955105,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-05-27T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2419159655,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-05-28T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2525444002,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-05-29T00:00:00.000",
                meetings: 3600.0,
                total: 9.0,
                correlation: 0.2470714669,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-05-30T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.241237793,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-05-31T00:00:00.000",
                meetings: 7200.0,
                total: 3.0,
                correlation: 0.2075180543,
                trend_line: 49.0843795187,
            },
            {
                datetime: "2023-06-01T00:00:00.000",
                meetings: 3600.0,
                total: 1.0,
                correlation: 0.2030977293,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-02T00:00:00.000",
                meetings: 3600.0,
                total: 3.0,
                correlation: 0.1990045301,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-03T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2084336202,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-06-04T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2084336202,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-06-05T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.1949362901,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-06T00:00:00.000",
                meetings: 5400.0,
                total: 1.0,
                correlation: 0.1840516281,
                trend_line: 66.5972845933,
            },
            {
                datetime: "2023-06-07T00:00:00.000",
                meetings: 3600.0,
                total: 6.0,
                correlation: 0.1843626105,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-08T00:00:00.000",
                meetings: 3600.0,
                total: 12.0,
                correlation: 0.1849800171,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-09T00:00:00.000",
                meetings: 3600.0,
                total: 52.0,
                correlation: 0.1873996256,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-10T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2011472221,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-06-11T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2011472221,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-06-12T00:00:00.000",
                meetings: 3600.0,
                total: 2.0,
                correlation: 0.187505149,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-13T00:00:00.000",
                meetings: 3600.0,
                total: 57.0,
                correlation: 0.1881344626,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-14T00:00:00.000",
                meetings: 7200.0,
                total: 66.0,
                correlation: 0.1895510979,
                trend_line: 49.0843795187,
            },
            {
                datetime: "2023-06-15T00:00:00.000",
                meetings: 3600.0,
                total: 68.0,
                correlation: 0.2178783847,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-16T00:00:00.000",
                meetings: 3600.0,
                total: 427.0,
                correlation: 0.2259454082,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-17T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2409604757,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-06-18T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2409604757,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-06-19T00:00:00.000",
                meetings: 3600.0,
                total: 12.0,
                correlation: 0.2266215649,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-20T00:00:00.000",
                meetings: 3600.0,
                total: 20.0,
                correlation: 0.2277378952,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-21T00:00:00.000",
                meetings: 3600.0,
                total: 52.0,
                correlation: 0.2236467899,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-22T00:00:00.000",
                meetings: 3600.0,
                total: 5.0,
                correlation: 0.2455040487,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-23T00:00:00.000",
                meetings: 3600.0,
                total: 35.0,
                correlation: 0.247782283,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-24T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2604041704,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-06-25T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2604041704,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-06-26T00:00:00.000",
                meetings: 3600.0,
                total: 186.0,
                correlation: 0.2546826545,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-27T00:00:00.000",
                meetings: 5400.0,
                total: 139.0,
                correlation: 0.254807626,
                trend_line: 66.5972845933,
            },
            {
                datetime: "2023-06-28T00:00:00.000",
                meetings: 7200.0,
                total: 146.0,
                correlation: 0.2713669781,
                trend_line: 49.0843795187,
            },
            {
                datetime: "2023-06-29T00:00:00.000",
                meetings: 3600.0,
                total: 33.0,
                correlation: 0.2658395619,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-06-30T00:00:00.000",
                meetings: 5400.0,
                total: 71.0,
                correlation: 0.2604509891,
                trend_line: 66.5972845933,
            },
            {
                datetime: "2023-07-01T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.267272418,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-07-02T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.267272418,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-07-03T00:00:00.000",
                meetings: 3600.0,
                total: 10.0,
                correlation: 0.2556809879,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-04T00:00:00.000",
                meetings: 3600.0,
                total: 41.0,
                correlation: 0.3027652767,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-05T00:00:00.000",
                meetings: 3600.0,
                total: 184.0,
                correlation: 0.3412522928,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-06T00:00:00.000",
                meetings: 3600.0,
                total: 164.0,
                correlation: 0.335064068,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-07T00:00:00.000",
                meetings: 9000.0,
                total: 15.0,
                correlation: 0.2856255953,
                trend_line: 29.9684198003,
            },
            {
                datetime: "2023-07-08T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2977478773,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-07-09T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2977478773,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-07-10T00:00:00.000",
                meetings: 3600.0,
                total: 14.0,
                correlation: 0.2860009524,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-11T00:00:00.000",
                meetings: 3600.0,
                total: 56.0,
                correlation: 0.2887588141,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-12T00:00:00.000",
                meetings: 12600.0,
                total: 34.0,
                correlation: 0.2344492529,
                trend_line: 30.7029208099,
            },
            {
                datetime: "2023-07-13T00:00:00.000",
                meetings: 3600.0,
                total: 44.0,
                correlation: 0.2470462675,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-14T00:00:00.000",
                meetings: 3600.0,
                total: 1.0,
                correlation: 0.2441732983,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-15T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.253797148,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-07-16T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.253797148,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-07-17T00:00:00.000",
                meetings: 3600.0,
                total: 2.0,
                correlation: 0.2428535633,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-18T00:00:00.000",
                meetings: 3600.0,
                total: 44.0,
                correlation: 0.2447173899,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-19T00:00:00.000",
                meetings: 3600.0,
                total: 68.0,
                correlation: 0.2479581926,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-20T00:00:00.000",
                meetings: 3600.0,
                total: 4.0,
                correlation: 0.2691738603,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-21T00:00:00.000",
                meetings: 3600.0,
                total: 72.0,
                correlation: 0.2731559205,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-22T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2853246786,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-07-23T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2853246786,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-07-24T00:00:00.000",
                meetings: 3600.0,
                total: 154.0,
                correlation: 0.2756111665,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-25T00:00:00.000",
                meetings: 5400.0,
                total: 9.0,
                correlation: 0.2672984824,
                trend_line: 66.5972845933,
            },
            {
                datetime: "2023-07-26T00:00:00.000",
                meetings: 7200.0,
                total: 11.0,
                correlation: 0.2588579713,
                trend_line: 49.0843795187,
            },
            {
                datetime: "2023-07-27T00:00:00.000",
                meetings: 3600.0,
                total: 18.0,
                correlation: 0.25973221,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-28T00:00:00.000",
                meetings: 3600.0,
                total: 12.0,
                correlation: 0.25973221,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-07-29T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2696012974,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-07-30T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2696012974,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-07-31T00:00:00.000",
                meetings: 3600.0,
                total: 91.0,
                correlation: 0.2604441162,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-01T00:00:00.000",
                meetings: 3600.0,
                total: 90.0,
                correlation: 0.2642269053,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-02T00:00:00.000",
                meetings: 3600.0,
                total: 104.0,
                correlation: 0.2647873446,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-03T00:00:00.000",
                meetings: 3600.0,
                total: 24.0,
                correlation: 0.2631223937,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-04T00:00:00.000",
                meetings: 3600.0,
                total: 76.0,
                correlation: 0.2633488474,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-05T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.3608127273,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-08-06T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.3608127273,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-08-07T00:00:00.000",
                meetings: 3600.0,
                total: 109.0,
                correlation: 0.3483876185,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-08T00:00:00.000",
                meetings: 3600.0,
                total: 169.0,
                correlation: 0.3425439904,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-09T00:00:00.000",
                meetings: 12600.0,
                total: 55.0,
                correlation: 0.3148975837,
                trend_line: 30.7029208099,
            },
            {
                datetime: "2023-08-10T00:00:00.000",
                meetings: 3600.0,
                total: 58.0,
                correlation: 0.3150169625,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-11T00:00:00.000",
                meetings: 3600.0,
                total: 70.0,
                correlation: 0.3186870025,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-12T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.3323138363,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-08-13T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.3323138363,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-08-14T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.3152868501,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-15T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.3272545145,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-16T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.3085660249,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-17T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.2637843035,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-18T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.2604184725,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-19T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2641526475,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-08-20T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2641526475,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-08-21T00:00:00.000",
                meetings: 3600.0,
                total: 14.0,
                correlation: 0.250358059,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-22T00:00:00.000",
                meetings: 5400.0,
                total: 25.0,
                correlation: 0.247287038,
                trend_line: 66.5972845933,
            },
            {
                datetime: "2023-08-23T00:00:00.000",
                meetings: 7200.0,
                total: 61.0,
                correlation: 0.255212808,
                trend_line: 49.0843795187,
            },
            {
                datetime: "2023-08-24T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.2704632191,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-25T00:00:00.000",
                meetings: 3600.0,
                total: 58.0,
                correlation: 0.2893915844,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-26T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.3306468839,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-08-27T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.3306468839,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-08-28T00:00:00.000",
                meetings: 3600.0,
                total: 7.0,
                correlation: 0.3165477185,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-29T00:00:00.000",
                meetings: 3600.0,
                total: 25.0,
                correlation: 0.3178541941,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-30T00:00:00.000",
                meetings: 3600.0,
                total: 11.0,
                correlation: 0.3148471496,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-08-31T00:00:00.000",
                meetings: 3600.0,
                total: 11.0,
                correlation: 0.3525470159,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-01T00:00:00.000",
                meetings: 3600.0,
                total: 107.0,
                correlation: 0.3492592592,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-02T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.3657112177,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-09-03T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.3657112177,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-09-04T00:00:00.000",
                meetings: 3600.0,
                total: 72.0,
                correlation: 0.3565857346,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-05T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.3561049149,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-06T00:00:00.000",
                meetings: 7200.0,
                total: 1.0,
                correlation: 0.3180527277,
                trend_line: 49.0843795187,
            },
            {
                datetime: "2023-09-07T00:00:00.000",
                meetings: 3600.0,
                total: 62.0,
                correlation: 0.3181107855,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-08T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.3173020102,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-09T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.3269302419,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-09-10T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.3269302419,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-09-11T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.3111504749,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-12T00:00:00.000",
                meetings: 3600.0,
                total: 304.0,
                correlation: 0.2556644985,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-13T00:00:00.000",
                meetings: 3600.0,
                total: 3.0,
                correlation: 0.2637148016,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-14T00:00:00.000",
                meetings: 3600.0,
                total: 12.0,
                correlation: 0.284461046,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-15T00:00:00.000",
                meetings: 3600.0,
                total: 9.0,
                correlation: 0.2832329908,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-16T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2952340295,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-09-17T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2952340295,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-09-18T00:00:00.000",
                meetings: 12600.0,
                total: 13.0,
                correlation: 0.2211823733,
                trend_line: 30.7029208099,
            },
            {
                datetime: "2023-09-19T00:00:00.000",
                meetings: 3600.0,
                total: 7.0,
                correlation: 0.2179457187,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-20T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.2141361523,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-21T00:00:00.000",
                meetings: 9000.0,
                total: 0.0,
                correlation: 0.18227783,
                trend_line: 29.9684198003,
            },
            {
                datetime: "2023-09-22T00:00:00.000",
                meetings: 7200.0,
                total: 81.0,
                correlation: 0.2042355308,
                trend_line: 49.0843795187,
            },
            {
                datetime: "2023-09-23T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2123432639,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-09-24T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.2123432639,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-09-25T00:00:00.000",
                meetings: 10800.0,
                total: 3.0,
                correlation: 0.1693430053,
                trend_line: 20.1933015326,
            },
            {
                datetime: "2023-09-26T00:00:00.000",
                meetings: 5400.0,
                total: 1.0,
                correlation: 0.1652270412,
                trend_line: 66.5972845933,
            },
            {
                datetime: "2023-09-27T00:00:00.000",
                meetings: 3600.0,
                total: 427.0,
                correlation: 0.1189030734,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-28T00:00:00.000",
                meetings: 3600.0,
                total: 12.0,
                correlation: 0.1083640794,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-29T00:00:00.000",
                meetings: 3600.0,
                total: 2.0,
                correlation: 0.106834123,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-09-30T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.112819808,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-10-01T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.112819808,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-10-02T00:00:00.000",
                meetings: 3600.0,
                total: 1.0,
                correlation: 0.1051247711,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-03T00:00:00.000",
                meetings: 3600.0,
                total: 137.0,
                correlation: 0.1068250678,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-04T00:00:00.000",
                meetings: 7200.0,
                total: 20.0,
                correlation: 0.1022397323,
                trend_line: 49.0843795187,
            },
            {
                datetime: "2023-10-05T00:00:00.000",
                meetings: 3600.0,
                total: 98.0,
                correlation: 0.1035725376,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-06T00:00:00.000",
                meetings: 3600.0,
                total: 102.0,
                correlation: 0.1049465222,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-07T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.1145698305,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-10-08T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.1145698305,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-10-09T00:00:00.000",
                meetings: 3600.0,
                total: 273.0,
                correlation: 0.1013628472,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-10T00:00:00.000",
                meetings: 3600.0,
                total: 328.0,
                correlation: 0.0964991665,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-11T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.0991514749,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-12T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.0948496463,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-13T00:00:00.000",
                meetings: 3600.0,
                total: 30.0,
                correlation: 0.0958009592,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-14T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.1048495365,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-10-15T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.1048495365,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-10-16T00:00:00.000",
                meetings: 3600.0,
                total: 35.0,
                correlation: 0.0952307671,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-17T00:00:00.000",
                meetings: 3600.0,
                total: 4.0,
                correlation: 0.0951293761,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-18T00:00:00.000",
                meetings: 7200.0,
                total: 157.0,
                correlation: 0.1253281819,
                trend_line: 49.0843795187,
            },
            {
                datetime: "2023-10-19T00:00:00.000",
                meetings: 3600.0,
                total: 79.0,
                correlation: 0.1266649731,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-20T00:00:00.000",
                meetings: 3600.0,
                total: 1.0,
                correlation: 0.1263553712,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-21T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.1350686285,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-10-22T00:00:00.000",
                meetings: 0.0,
                total: 0.0,
                correlation: 0.1350686285,
                trend_line: 0.0787110108,
            },
            {
                datetime: "2023-10-23T00:00:00.000",
                meetings: 3600.0,
                total: 119.0,
                correlation: 0.1263607769,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-24T00:00:00.000",
                meetings: 3600.0,
                total: 180.0,
                correlation: 0.1260761323,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-25T00:00:00.000",
                meetings: 3600.0,
                total: 65.0,
                correlation: 0.1276157114,
                trend_line: 71.5632389297,
            },
            {
                datetime: "2023-10-26T00:00:00.000",
                meetings: 3600.0,
                total: 0.0,
                correlation: 0.1437813558,
                trend_line: 71.5632389297,
            },
        ],
        explanation:
            "This is the graph is showing the correlation between time spent on meetings a day and the lines of code committed that day.\n            Any data points above the 0.2 and below the -0.2 lines have a statistically significant correlation.\n            ",
        description:
            "It has been produced by calculating the correlation coefficient on a rolling window of 20 days, in order to smoothen the curve and depict the general direction of the move while minimizing the noise. This means that we take a window of the 20 first days of data and we calculate the correlation coefficient, then we remove the oldest day and we add an earlier one, calculating again the correlation, and we keep doing that until we reach the end of the dataset, meaning yesterday.\n            \n            These have been the best settings we have found to be working better for this calculation. However, we will allow you to set this settings in any value you see more fit.\n            \n            Any data points above the 0.2 line have a statistically significant positive correlation, meaning when one of the variable increases the other one does too. Also any data points below -0.2 represent a\n            statistically significant negative correlation, meaning when one variable increases the other one does reduce. The higher or lower from 0 a data point is the more positively or negatively our two variables are correlated indicatign that they potentially affect each other more.\n            ",
        error: null,
    },
};
export default meetingsToLinesResp;
